import React, { useState, useRef, useEffect } from "react";
import { Input, Button, Space, message } from "antd";
import eyeIcon from "../../../Assets/Icons/eye.svg";
import { SearchOutlined } from "@ant-design/icons";
import GenericTable from "../../../Components/GenericTable";
import locationIcon from "../../../Assets/Icons/location.svg";
import addIcon from "../../../Assets/Icons/add-btn.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { getHighRiskActivity } from "../../../API/User/highriskactivity";

const HighRiskActivity = () => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [loading, setLoading] = useState(false);
  const [highRiskActivities, setHighRiskActivites] = useState();

  const [messageApi, contextHolder] = message.useMessage();

  const searchInput = useRef(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getHighRiskActivity();

      if (Math.floor(response?.status / 100) === 2) {
        const raw = response?.data?.vehicles || [];

        setHighRiskActivites(
          raw.map((item, index) => ({
            key: index + 1,
            fullData: item,
            customer_name: item.customer.customer_name,
            vehicle_name: item.vehicle.vehicle_name,
            status: item.status,
            risk_score: item.score.total_score,
            reason: item.reason,
          })),
        );
      } else {
        messageApi.error("Unexpected response from server.");
      }
    } catch (err) {
      messageApi.error("Failed to fetch high risk activites.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const highlightText = (text) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = String(text).split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "yellow",
            color: "#d32f2f",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    setSearchText("");
    confirm();
  };
  const handleClick = () => {
    navigate("/add-high-risk");
  };

  const showDetails = (id) => {
    navigate(`/view-high-risk-detail/${id}`);
  };
  const customerColumns = [
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text) => highlightText(text),
      ...getColumnSearchProps("customer_name"),
    },
    {
      title: "Vehicle",
      dataIndex: "vehicle_name",
      key: "vehicle",
      render: (text) => highlightText(text),
      ...getColumnSearchProps("vehicle"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const display = status.replace(/([A-Z])/g, " $1").trim();
        return (
          <span className={`status-badge ${status.toLowerCase()}`}>
            {display}
          </span>
        );
      },
      filters: [
        { text: "Unanswered", value: "unanswered" },
        { text: "Unverified", value: "unverified" },
        { text: "Not Theft", value: "notTheft" },
        { text: "Verified Theft", value: "verifiedTheft" },
      ],
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "High-Risk Activity Score",
      dataIndex: "risk_score",
      key: "risk_score",
      sorter: (a, b) => a.risk_score - b.risk_score,
      render: (risk_score) => <span className="risk-badge">{risk_score}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <a
          onClick={() =>
            navigate(`/view-high-risk-detail/${record.vehicle_name}`, {
              state: record.fullData,
            })
          }
        >
          <img src={eyeIcon} alt="view" />
        </a>
      ),
    },
  ];

  return (
    <div className="high-risk">
      {contextHolder}
      <div className="button">
        {/* <Button type="default" onClick={handleClick} className="add-btn">
          <img src={addIcon} alt="add user" className="btn-icon" />
          Add Activity
        </Button> */}
      </div>

      <div className="table">
        <GenericTable
          dataSource={highRiskActivities}
          columns={customerColumns}
        />
      </div>
    </div>
  );
};

export default HighRiskActivity;
